<div class="grid-x accordion-heading">
  <div class="cell small-12 bold">
    Context Locations for Well Data from earlier in the flow (One answer possible per flow)
    <button (click)="accordion('single')">
      @if (sectionIsVisible('single')) {
        <svg-icon icon="icon-circle-arrow-down" class="tiny dark-gray"></svg-icon>
      }
      @if (!sectionIsVisible('single')) {
        <svg-icon icon="icon-circle-arrow-right" class="tiny dark-gray"></svg-icon>
      }
    </button>
  </div>
</div>
@if (sectionIsVisible('single')) {
  @for (opt of singleEntryOptions; track opt) {
    <div class="grid-x">
      <div class="cell small-5 small-font-size">
        {{opt.displayName}} :
      </div>
      <div class="cell small-7">
        <input type="text" [id]="opt.displayName" [(ngModel)]="opt.location" />
      </div>
    </div>
  }
}
@if (multipleEntryOptions.length > 0) {
  <div class="grid-x accordion-heading">
    <div class="cell small-12 bold">
      Context Locations for Well Data from earlier in the flow (More than one answer possible per flow)
      <button (click)="accordion('multiple')">
        @if (sectionIsVisible('multiple')) {
          <svg-icon icon="icon-circle-arrow-down" class="tiny dark-gray"></svg-icon>
        }
        @if (!sectionIsVisible('multiple')) {
          <svg-icon icon="icon-circle-arrow-right" class="tiny dark-gray"></svg-icon>
        }
      </button>
    </div>
  </div>
}
@if (sectionIsVisible('multiple')) {
  @for (opt of multipleEntryOptions; track opt) {
    @for (entry of opt.multipleLocations; track entry; let i = $index) {
      <div class="grid-x">
        <div class="cell small-5 small-font-size">
          {{opt.displayName}} [{{i}}] @if (i === opt.multipleLocations.length - 1) {
          <button (click)="addEntry(opt)"><svg-icon icon="icon-plus" class="small"></svg-icon></button>
        }
      </div>
      <div class="cell small-7 small-font-size">
        <input type="text" [id]="generateMultiId(opt.displayName, i)" [(ngModel)]="opt.multipleLocations[i]" (blur)="log()" />
      </div>
    </div>
  }
}
}
